import { DropdownContent } from '@anm/components/Dropdown';
import ButtonLoader, { Content as ButtonContent, LoaderWrapper } from '@anm/components/buttons/ButtonLoader';
import Alert from '@anm/components/notification/Alert';
import {
  AccountListWrapper,
  DestinationRow
} from '@anm/components/stream/destination_management/DestinationAccountList/AccountList/Wrapper';
import { flexColumn, media, osScrollBar } from '@anm/styles/helpers';
import styled from 'styled-components';

import { commonMessageStyles, WarnMessage } from '../StreamDetailsStep/Wrapper';

export const LimitWarning = styled(WarnMessage)`
  margin: 15px 0 -10px;
`;

const dividerMobile = media.phone`
  left: -16px;
  width: calc(100% + 32px);
`;

export const DividerLine = styled.div`
  position: relative;
  &:after {
    content: '';
    top: 0;
    height: 1px;
    left: -32px;
    position: absolute;
    width: calc(100% + 64px);
    background: var(--gray_100);
    ${dividerMobile};
  }
`;

const mobileContent = media.phone`
  margin: 0;
  padding: 0;
`;

export const Content = styled.div`
  flex: 1;
  min-height: 400px;
  max-height: calc(100vh - 285px);
  overflow-y: auto;
  position: relative;
  margin-right: -20px;
  margin-left: -20px;
  padding-right: 20px;
  padding-left: 20px;
  padding-bottom: 26px;
  ${osScrollBar};
  ${mobileContent};
`;

export const AddDestinationWrapper = styled.div`
  margin: 24px 0 16px 10px;

  ${DropdownContent} {
    left: 97px;
    width: 190px;
  }
`;

export const DestinationsDescription = styled.p`
  margin: 0 0 12px;
  text-align: center;
  color: var(--gray_400);
`;

export const ErrorMessage = styled(Alert)`
  margin-bottom: 16px;
  && {
    ${commonMessageStyles};
  }
`;

export const LearnMore = styled.a`
  color: var(--gray_900);
  text-decoration: underline;
`;

export const FooterWrapper = styled.div`
  ${flexColumn};
  padding-top: 16px;
`;

export const SubmitButton = styled(ButtonLoader)<{ isPending: boolean; isUploading: boolean }>`
  margin: 0 auto;
  max-width: 240px;
  position: relative;

  ${LoaderWrapper} {
    left: ${({ isUploading }) => (isUploading ? '14%' : 'unset')};
  }

  ${ButtonContent} {
    opacity: ${({ isPending, isUploading }) => (isUploading || !isPending ? 1 : 0)};
    margin-left: ${({ isPending, isUploading }) => (isUploading || isPending ? 20 : 0)}px;
  }
`;

export const DestinationsWrapper = styled.div`
  ${AccountListWrapper}:last-of-type {
    margin: 0;
    ${DestinationRow}:last-of-type {
      margin: 0;
    }
  }
`;
